import Checkbox from 'apollo-react/components/Checkbox';
import React from 'react';

export const CheckboxCell = ({ row: { id, selectedRows, handleSelectRow } }) => (
  <Checkbox checked={selectedRows?.has(id)} onChange={() => handleSelectRow(id)} />
);
